export default __webpack_public_path__ + "static/media/card-lab-icon.04decaa4.svg";